// Invite / multi-select user search: open #showUserModal with /profile/:id.js (same as shared/footer showUserProfile).

function openSelectUserProfileModal (userId) {
  if (!userId) return
  const id = String(userId)
  const loadingHtml = '<div class="text-center py-4"><div class="spinner-border text-secondary" role="status"><span class="visually-hidden">Loading...</span></div><p class="mt-2 text-muted mb-0 small">Loading profile…</p></div>'

  if (typeof window.showUserProfile === 'function') {
    window.showUserProfile(id)
    return
  }

  const $ = window.jQuery
  if (!$ || !$.fn || !$('#showUserModal').length) return

  $('#showUserModal .modal-body').html(loadingHtml)
  $('#showUserModal').modal('show')
  $.ajax({
    url: '/profile/' + encodeURIComponent(id) + '.js',
    type: 'GET',
    dataType: 'script',
    error: function () {
      $('#showUserModal .modal-body').html('<p class="text-danger mb-0 small">Could not load profile. Please try again.</p>')
    }
  })
}

function clickTargetElement (e) {
  const t = e.target
  if (t && t.nodeType === Node.ELEMENT_NODE) return t
  return t && t.parentElement
}

document.addEventListener('click', function (e) {
  const el = clickTargetElement(e)
  const btn = el && el.closest ? el.closest('.js-invite-user-profile-btn') : null
  if (!btn) return
  e.preventDefault()
  e.stopPropagation()
  const uid = btn.getAttribute('data-user-id')
  openSelectUserProfileModal(uid)
})

window.openSelectUserProfileModal = openSelectUserProfileModal
